import { BrowserModule } from '@angular/platform-browser';
import 'javascript-time-ago/locale/pt'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptorService } from './core/interceptor/auth.interceptor.service';
import { ErrorComponent } from './core/component/error/error.component';
import { NavBarModule } from './core/component/nav-bar/nav-bar.module';
import { ErrorInterceptorService } from './core/interceptor/error.interceptor.service';

import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import TimeAgo from 'javascript-time-ago';

registerLocaleData(ptBr);
TimeAgo.setDefaultLocale('pt')

@NgModule({
    declarations: [
        AppComponent,
        ErrorComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NavBarModule,
        HttpClientModule,
    ],
    providers: [
        provideAnimationsAsync(),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
